import React, { useState } from 'react'
import { Link, NavLink, useLocation, useNavigate } from 'react-router-dom'
import '../assets/css/Navbar.css'
import { useAuth } from '../context/AuthContext'
import Logo from './Logo'
import userIcon from '../assets/icons/icons8-male-user-50.png'
import walletIcon from '../assets/icons/icons8-wallet-32.png'
import { useCheckoutOverlay } from '../context/CheckoutContext'
import {Popover} from '../UI/popover/Popover.tsx'
import Overlay from './Overlay'
import WalletForm from './WalletForm'
import useLogout from '../hooks/useLogout'
import MyTextarea from '../UI/textarea/MyTextarea'
import MyButton from '../UI/button/MyButton'
import instance from '../interceptors/AxiosInterceptor'
import { toast } from 'react-toastify'
import { CircleSpinner } from 'react-spinner-overlay'
import { FaBars, FaTimes } from 'react-icons/fa'
import { useDMSContext } from '../context/DMSContext'
import { useScreenWidth } from '../hooks/useScreenWidth'
export default function Navbar() {
        const [menuOpen, setMenuOpen] = useState(false)
        const { isLoggedIn, authUser} = useAuth();
        const logout = useLogout();
        const location = useLocation();
        const { showCheckoutOverlay, handleCheckoutOverlay } = useCheckoutOverlay();
        const [showFeedbackOverlay, setShowFeedbackOverlay] = useState(false);
        const [isPopoverOpen, setIsPopoverOpen] = useState(false);
        const [popoverOpen, setPopoverOpen] = useState(false);
        const navigate = useNavigate();
        const [feedbackText, setFeedbackText] = useState('');
        const {sidebarOpen, toggleSidebar} = useDMSContext();
        const { isMobileWidth } = useScreenWidth(1043);
        const [loading, setLoading] = useState(false);
        const userDetails = authUser ?  authUser.email + "\n" + authUser.name + "\n" + authUser.telephoneNumber : "nullUser";
        const handleFeedback = async (e) =>{
          e.preventDefault();
          try {
            setLoading(true);
            await instance.post('https://api.prolex.md/api/calculator/sendFeedback',{
              message: feedbackText,
              calcDetails: userDetails
          },{
              withCredentials: true});
              toast.success('Feedback-ul a fost trimis cu succes.', {
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
            setShowFeedbackOverlay(false);
          } catch (error) {
            toast.success('Eroare.Încercați mai târziu.', {
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
          });
          }finally{
            setLoading(false);
          }
        }
  return (
    <nav className='hide-on-print header'>
     { isMobileWidth ? <div style={{display:"flex"}}>
       <span className="sidebar-toggle-btn" onClick={toggleSidebar} style={{padding:"1rem", alignSelf:"center", cursor:"pointer"}}>
          {sidebarOpen ? <FaTimes size={24}/> : <FaBars size={24}/>}
        </span>
        <Link to={"/"} className="nav-title">
            <Logo  style={{display:"hidden"}}/>
        </Link>
       </div> :
        <Link to={"/"} className="nav-title">
        <Logo  style={{display:"hidden"}}/>
    </Link>}
        {/*<div className='menu' onClick={() => setMenuOpen(!menuOpen)}>*/}
        
        <Popover
                  isOpen={popoverOpen}
                  positions={['bottom']}
                  padding={2}
                  onClickOutside={() => setPopoverOpen(false)} 
                  content={({ position, childRect, popoverRect }) => (
                    <div
                    style={{
                      backgroundColor: '#f1f4f9',
                      width: '100vw',
                      borderRadius: '0px 0px 5px 5px',
                      border: '1px solid lightgrey',
                      fontFamily: 'Montserrat, sans-serif',
                      fontSize: '14px',
                      lineHeight: '1.6'
                    }}
                    onMouseLeave={() => setPopoverOpen(false)} 
                  >
                    <div
                      className="body"
                      style={{
                        padding: '2px',
                        alignItems: 'center'
                      }}
                    >
                      <ul style={{ listStyleType: 'none', padding: 0 }}>
                      {authUser ?  <>
                        <li>
                          <NavLink to="/dashboard" className='nav-option'onClick={() => setPopoverOpen(false)}>
                            Cabinet personal
                          </NavLink>
                        </li>
                        <li>
                          <NavLink to="/calculator" className='nav-option'onClick={() => setPopoverOpen(false)}>
                            Calculator
                          </NavLink>
                        </li>
                        <li>
                          <NavLink to="/dms" className='nav-option'onClick={() => setPopoverOpen(false)}>
                            Management Debitori
                          </NavLink>
                        </li>
                        <li>
                          <div className="nav-option" onClick={() => {setPopoverOpen(false);setShowFeedbackOverlay(!showFeedbackOverlay)}}>
                            Lasă un Feedback
                          </div>
                        </li>
                        <li>
                          <div className="nav-option exit" onClick={() => {setPopoverOpen(false);logout();}}>
                            Ieși din cont
                          </div>
                        </li>
                      </>:
                      <>
                       <li>
                          <NavLink to="/calculator" className='nav-option'onClick={() => setPopoverOpen(false)}>
                            Calculator
                          </NavLink>
                        </li>
                        <li><NavLink className="nav-option" to={"/login"} state={{ prev: location.pathname }} onClick={() => {setPopoverOpen(false);setMenuOpen(false)}}>Autentificare</NavLink></li>
                        <li><NavLink className="nav-option" to={"/register"} onClick={() => {setPopoverOpen(false);setMenuOpen(false)}}>Înregistrare</NavLink></li>
                      </>}
                      </ul>
                    </div>
                  </div>
                )}
              >
                <div
                  onClick={()=>{setPopoverOpen(!popoverOpen)}}
                  onMouseEnter={() => setPopoverOpen(true)}
                >
                 <div className='menu'>
        <img src={userIcon} alt="" />
        </div>
                </div>
              </Popover>
        <ul className={menuOpen ? "open" : ""}>
          <div className='menu-left'>
            {/* <li><NavLink to={"/penalitate"} className="navbar-link" onClick={() => setMenuOpen(false)}>Penalitate</NavLink></li>
            <li><NavLink to={"/dobanda"} className="navbar-link" onClick={() => setMenuOpen(false)}>Dobânda de întârziere</NavLink></li>
            <li><NavLink to={"/inflatie"} className="navbar-link" onClick={() => setMenuOpen(false)}>Calcul inflație</NavLink></li>
            <li><NavLink to={"/imputatia"} className="navbar-link" onClick={() => setMenuOpen(false)}>Imputația</NavLink></li>
            <li><NavLink to={"/zile"} className="navbar-link" onClick={() => setMenuOpen(false)}>Calcul zile</NavLink></li> */}

            <li><NavLink to={"/calculator"} className="navbar-link" onClick={() => setMenuOpen(false)}>Calculator</NavLink></li>
            <li><NavLink to={"/dms"} className="navbar-link" onClick={() => setMenuOpen(false)}>Management Debitori</NavLink></li>

            <li><a href="https://taxa.prolex.md" className="navbar-link" target="_blank">Taxa</a></li>
          </div>
            <div className='menu-right'>
              {isLoggedIn && authUser.parentUserId == null ? 
            <li className='hide-on-mobile nav-wallet' onMouseEnter={() => setIsPopoverOpen(false)}>
            <div className='wallet' onClick={handleCheckoutOverlay}>
            <img src={walletIcon} alt="" />
            {authUser.subscription == null ? authUser.balance : null}
            </div>
            </li>  
            : null}
              {isLoggedIn 
            ? 
            <>
                <Popover
                  isOpen={isPopoverOpen}
                  positions={['bottom']}
                  padding={2}
                  onClickOutside={() => setIsPopoverOpen(false)}
                  content={({ position, childRect, popoverRect }) => (
                    <div
                    style={{
                      backgroundColor: '#f1f4f9',
                      width: '200px', 
                      borderRadius: '0px 0px 5px 5px',
                      border: '1px solid lightgrey',
                      fontFamily: 'Montserrat, sans-serif',
                      fontSize: '14px',
                      lineHeight: '1.6'
                    }}
                    onMouseLeave={() => setIsPopoverOpen(false)}
                  >
                    <div
                      className="body"
                      style={{
                        padding: '2px',
                        alignItems: 'center'
                      }}
                    >
                      <ul style={{ listStyleType: 'none', padding: 0 }}>
                      {authUser ?  <>
                        <li>
                          <NavLink to="/dashboard" className='nav-option'onClick={() => setIsPopoverOpen(false)}>
                            Cabinet personal
                          </NavLink>
                        </li>
                        <li>
                          <div className="nav-option" onClick={() => {setIsPopoverOpen(false);setShowFeedbackOverlay(!showFeedbackOverlay)}}>
                            Lasă un Feedback
                          </div>
                        </li>
                        <li>
                          <div className="nav-option exit" onClick={() => {setIsPopoverOpen(false);logout();}}>
                            Ieși din cont
                          </div>
                        </li>
                      </>:
                      <>
                        <li><NavLink to={"/login"} state={{ prev: location.pathname }} onClick={() => setMenuOpen(false)}>Autentificare</NavLink></li>
                        <li><NavLink to={"/register"} onClick={() => setMenuOpen(false)}>Înregistrare</NavLink></li>
                      </>}
                      </ul>
                    </div>
                  </div>
                )}
              >
                <div
                onClick={()=>{setIsPopoverOpen(false);navigate("/dashboard");}}
                onMouseEnter={() => setIsPopoverOpen(true)}
                >
                  <li className='nav-option'>{authUser && authUser.name}</li>
                </div>
              </Popover>
            </>
            : <>
              <li><NavLink to={"/login"} state={{ prev: location.pathname }} onClick={() => setMenuOpen(false)}>Autentificare</NavLink></li>
              <li><NavLink to={"/register"} onClick={() => setMenuOpen(false)}>Înregistrare</NavLink></li>
              </>
              }
            </div>
        </ul>
        <Overlay
        isOpen={showCheckoutOverlay}
        handleOverlay={handleCheckoutOverlay}
        children={<WalletForm/>}
        />
        <Overlay
        isOpen={showFeedbackOverlay}
        handleOverlay={()=>{setShowFeedbackOverlay(!showFeedbackOverlay);}}
        children={
          <form onSubmit={handleFeedback}>
            <span className='myInpLabel'>Feedback</span>
            <MyTextarea
              name='feedback'
              label='Feedback'
              value={feedbackText}
              onChange={(e) => setFeedbackText(e.target.value)}
            />
          <MyButton
          body={loading ? <div className="spinner-container"><CircleSpinner loading={loading} color='#1b1b1bff' />
          </div>:"Expediază"}
          className = "button-with-loader"
          />
          </form>
        }
        />
    </nav>
  )
}
